import { buildGuestRegionHeaders } from '@/helpers'
import { createEvent, sample, type EventCallable } from 'effector'
import { model as session } from '~/entities/session'
import { preferencesFeatureModel } from '~/features/preferences'
import * as features from './features'
import * as modules from './modules'

export const init: EventCallable<void> = createEvent()

// load features on init
// Set header only if guest selected region
sample({
  clock: init,
  source: {
    isNotAuthenticated: session.$isNotAuthenticated,
    region: preferencesFeatureModel.$preference,
  },
  fn: ({ isNotAuthenticated, region }) =>
    buildGuestRegionHeaders({
      isNotAuthenticated,
      regionId: region?.id,
    }),
  target: features.getFx,
})

sample({
  clock: [init, preferencesFeatureModel.$preference],
  source: {
    isNotAuthenticated: session.$isNotAuthenticated,
    region: preferencesFeatureModel.$preference,
  },
  fn: ({ isNotAuthenticated, region }) =>
    buildGuestRegionHeaders({
      isNotAuthenticated,
      regionId: region?.id,
    }),
  target: modules.getModulesFx,
})
